<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<button #focusableEleTop class="focusable-element"></button>
<div class="row" *ngIf="error || invalidAgent">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngIf="error"><button>AgentID is required</button></li>
                <li *ngIf="invalidAgent"><button>Login ID '{{this.userName}}' not found.</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>User Search</h1>
        </div>
    </div> 
    <div>
        <form (keydown)="onFindKeyDown($event)">
            <fieldset>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Login ID'"
                                                [text]="this.userName"
                                                (onValueChange)="selectedValueChange($event)"
                                                [disabled]="false">
                            </ValidatedTextField>
                            <span style="color:#cc0000; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: .6em;">Complete "Login ID" needed, the search will only match to one login ID.</span>
                        </div>                        
                    </div>
                </div>
            </fieldset>
        </form>
        <div class="row">
            <div class="col-24">
                <button id="searchAgent" class="button primary" (click)="searchAgent()">Search</button>
            </div>
        </div>
    </div>
</div>

